import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Autocomplete, Button, Chip, Grid, IconButton, Stack, TextField } from '@mui/material';
import AttToken from '../../../helpers/attToken';
import { userBackObj } from '../../Users/UserSearch';
import { types } from '../../../service/ServiceTypes';
import { useEffect, useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { CardActionArea } from '@mui/material';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import Clients from '../../../service/Clients';
import ServicePlaceAssociation from './ServicePlacesAssociation';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { manageType } from '../NewManages';
import Manages from '../../../service/Manages';
import queryClient from '../../../service/query';
import { toast } from 'react-toastify';
import QueryFn from '../../../helpers/QueryFn';
import { IoCloseCircle } from 'react-icons/io5';

const customerService = new Clients();
const manageService = new Manages();
const queryFn = new QueryFn();

export default function NewMgmtModal({
  open,
  setOpen,
  results,
  selectedManage,
  setSelectedManage,
}: {
  open: boolean,
  setOpen: Function,
  results: any,
  selectedManage: manageType | null,
  setSelectedManage: Function,
}) {
  const [name, setName] = useState<string | null>(selectedManage?.nome || null);
  const [manages, setManages] = useState<string[] | null>(selectedManage?.gerentes || []);
  const [teams, setTeams] = useState<{ id: string, nome: string }[] | null>(selectedManage?.equipes || []);
  const [serviceTypes, setServiceTypes] = useState<{ id: string, nome: string, conjuntosAssociados: string[] }[] | null>(selectedManage?.tiposDeServico || []);
  const [selectService, setSelectedService] = useState<string | null>(null);
  const [conjuntosArray, setConjuntosArray] = useState<string[]>([]);
  const [status, setStatus] = useState<string>('ativo');
  const [expand, setExpand] = useState(selectedManage?.geral ? true : false);

  useEffect(() => {
    if (selectedManage) {
      setStatus(selectedManage.status ? 'ativo' : 'inativo');
    }
  }, []);

  const { mutate, isPending: isLoadingPlaces, data } = queryFn.useMutate('GET_PLACES',
    async (value: string) => {
      const token = await AttToken();
      if (token) {
        const response = await customerService.getAllWithSets(token, value);
        return response;
      }
    }
  );

  const { mutate: edit, isPending: isLoadingEdit, isSuccess: onSuccessEdit, isError: onErrorEdit } = queryFn.useMutate('EDIT_MANAGE',
    async () => {
      toast.warn('Alterando gerencia, aguarde...');
      const token = await AttToken();
      if (token && selectedManage) {
        delete selectedManage?.dataDelecao;
        await manageService.editV2(token, selectedManage);

      }
    },
  );
  if (onSuccessEdit) {
    setOpen(false);
    queryClient.resetQueries({ queryKey: ['GET_MANAGESv2'] });
    toast.success('Gerencia alterada com sucesso!');
    setSelectedManage(null);
  }

  if (onErrorEdit) {
    toast.error('Erro ao alterar gerencia');
    setSelectedManage(null);
  }

  const { mutate: create, isPending: isLoadingCreate, isSuccess: onSuccessCreate, isError: onErrorCreate } = queryFn.useMutate('CREATE_MANAGE',
    async () => {
      toast.warn('Criando gerencia, aguarde...');
      const token = await AttToken();
      if (token && selectedManage) {
        delete selectedManage?.dataDelecao;
        await manageService.createV2(token, selectedManage);
      }
    },
  );

  if (onSuccessCreate) {
    setOpen(false);
    queryClient.resetQueries({ queryKey: ['GET_MANAGESv2'] });
    toast.success('Gerencia criada com sucesso!');
    setSelectedManage(null);
  }
  if (onErrorCreate) {
    toast.error('Erro ao criar gerencia');
    setSelectedManage(null);
  }
  useEffect(() => {
    let conjuntos = serviceTypes?.find((ele) => ele.id === selectService);
    if (conjuntos) {
      conjuntos.conjuntosAssociados = conjuntosArray;
    }
  }, [conjuntosArray]);

  useEffect(() => {
    setSelectedManage({
      ...selectedManage,
      nome: name,
      dataAlteracao: selectedManage?.id ? new Date().getTime() : null,
      gerentes: manages,
      equipes: teams,
      tiposDeServico: serviceTypes,
      status: status === 'ativo' ? true : false,
    });
  }, [name, manages, teams, serviceTypes, status, conjuntosArray]);

  const close = () => {
    setOpen(false);
    setSelectedManage(null);
  };

  const escape = (e: any) => {
    if (e.key === 'Escape') {
      close();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', escape, true);
  }, [escape]);

  return (
    <div className={`modal ${open ? "modal is-active" : "modal"}`}>
      <div className="modal-background" onClick={() => close()} onKeyDown={(e: any) => escape(e)} />
      <div className="modal-card">
        <header className="modal-card-head">
          <Typography className="modal-card-title" variant='h5'>{`${selectedManage?.id ? 'Edição' : 'Criação'}`} de gerência</Typography>
          {!selectService
            ? <IconButton
              onClick={() => close()}
              className='delete'>
              <CancelIcon
                color='error'

              />
            </IconButton>
            : <Button
              onClick={() => setSelectedService(null)}
              startIcon={
                <ArrowCircleLeftIcon
                  color='primary'
                />
              }>
              Voltar
            </Button>
          }
        </header>
        <section className="modal-card-body">
          <>
            {selectService
              ? <ServicePlaceAssociation
                conjuntosArray={conjuntosArray}
                setConjuntosArray={setConjuntosArray}
                isLoading={isLoadingPlaces}
                clients={data}
                tipoServico={selectService}
                disabled={selectedManage?.geral ? true : false}
              />
              : <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
              >
                <TextField
                  label='Nome'
                  fullWidth
                  value={name || ''}
                  onChange={(eve) => setName(eve.target.value)}
                />
                <Autocomplete
                  disabled={selectedManage?.geral}
                  id="combo-box-demo"
                  defaultValue={manages?.map((ele: string) => ({
                    aliasname: ele,
                    nome: results[1].data?.users?.find((elem: any) => elem.aliasname === ele)?.nome || ''
                  })) || []}
                  options={
                    results[1].data?.users
                      ?.filter((user: userBackObj) => user.perfil === 'Gestor' || user.perfil === 'Gerente')
                      ?.filter((user: userBackObj) => !manages?.includes(user.aliasname))
                      ?.sort((a: userBackObj, b: userBackObj) => { return a.nome?.toLowerCase() > b.nome?.toLowerCase() ? 1 : - 1; })
                      ?.map((user: userBackObj) => (
                        { aliasname: user.aliasname, nome: user.nome }
                      )) || []
                  }
                  fullWidth
                  filterSelectedOptions
                  multiple
                  renderInput={(params) => <TextField {...params} label="Gerentes" />}
                  getOptionLabel={(option) => option.nome || ''}
                  isOptionEqualToValue={(option: { aliasname: string, nome: string }, value) => option === value}
                  renderOption={(props, option: { aliasname: string, nome: string }) => (
                    <li {...props} key={option.aliasname}>
                      <span>{option.nome}</span>
                    </li>)}
                  onChange={(event: any, newValue: { aliasname: string, nome: string }[] | null) => {
                    let managesList: string[] = [];
                    newValue?.forEach((ele) => {
                      managesList.push(ele.aliasname);
                    });
                    setManages(managesList);
                  }}
                  renderTags={(tagValue, getTagProps) => {
                    return tagValue?.map((option: any, index) => (
                      <Chip {...getTagProps({ index })} label={option.nome} />
                    ));
                  }}
                />
                <Autocomplete
                  disabled={selectedManage?.geral}
                  id="combo-box-demo"
                  multiple
                  filterSelectedOptions
                  defaultValue={teams?.map((ele) => ({
                    ...ele
                  })) || []}
                  options={
                    results[2].data
                      ?.sort((a: { id: string, nome: string }, b: { id: string, nome: string }) => { return a.nome?.toLowerCase() > b.nome?.toLowerCase() ? 1 : - 1; })
                      ?.map((team: { id: string, nome: string }) => (
                        { id: team.id, nome: team.nome }
                      )) || []
                  }
                  fullWidth
                  renderInput={(params) => <TextField {...params} label="Equipes" />}
                  getOptionLabel={(option) => option.nome || ''}
                  isOptionEqualToValue={(option: { id: string, nome: string }, value) => option.id === value.id}
                  renderOption={(props, option: { id: string, nome: string }) => (
                    <li {...props} key={option.id}>
                      <span>{option.nome}</span>
                    </li>)}
                  onChange={(event, value: { id: string, nome: string }[] | null) => {
                    setTeams(value);
                  }}
                  renderTags={(tagValue, getTagProps) => {
                    return tagValue?.map((option, index) => (
                      <Chip {...getTagProps({ index })} label={option.nome} />
                    ));
                  }}
                />

                <Accordion sx={{ width: '100%' }} expanded={expand}>
                  <AccordionSummary
                    onClick={() => setExpand(!expand)}
                    expandIcon={<ArrowDownwardIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography variant='h6'>Tipos de serviço</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {serviceTypes && serviceTypes?.length > 0 &&
                      <Box sx={{ width: '100%', marginBottom: '15px' }}>
                        <Grid container rowSpacing={1} columnSpacing={1}>
                          {serviceTypes?.map((service) => (
                            <Grid size={6}>
                              <Card onClick={() => {
                                setSelectedService(service.id);
                                setConjuntosArray(service?.conjuntosAssociados);
                                mutate(service.id);
                              }}>
                                <CardActionArea>
                                  <CardContent>
                                    <Stack
                                      direction="row"
                                      justifyContent="space-between"
                                      alignItems="center"
                                    >
                                      <Typography variant='subtitle2'>
                                        Hierarquia Associada a "{service.nome}"
                                      </Typography>
                                      <ArrowCircleRightIcon color='primary' />
                                    </Stack>
                                  </CardContent>
                                </CardActionArea>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>}
                    <Autocomplete
                      disabled={selectedManage?.geral}
                      id="combo-box-demo"
                      defaultValue={serviceTypes?.map((ele) => ({
                        ...ele
                      })) || []}
                      multiple
                      filterSelectedOptions
                      options={
                        results[3].data
                          ?.sort((a: types, b: types) => { return a.nome?.toLowerCase() > b.nome?.toLowerCase() ? 1 : - 1; })
                          ?.map((service: types) => {
                            return (
                              {
                                id: service.tipoId,
                                nome: service.nome,
                                conjuntosAssociados: service.conjuntos
                              });
                          }) || []}
                      fullWidth
                      renderInput={(params) => <TextField {...params} label="Tipos de serviço" />}
                      getOptionLabel={(option) => option.nome || ''}
                      isOptionEqualToValue={(option: { id: string, nome: string, conjuntosAssociados: string[] }, value) => option.id === value.id}
                      renderOption={(props, option: { id: string, nome: string, conjuntosAssociados: string[] }) => (
                        <li {...props} key={option.id}>
                          <span>{option.nome}</span>
                        </li>)}
                      onChange={(event, value: { id: string, nome: string, conjuntosAssociados: string[] }[] | null) => {
                        setServiceTypes(value);
                      }}
                      renderTags={(tagValue, getTagProps) => {
                        return tagValue?.map((option, index) => (
                          <Chip {...getTagProps({ index })} label={option.nome} />
                        ));
                      }}
                    />
                  </AccordionDetails>
                </Accordion>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Select
                    disabled={selectedManage?.geral}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={status}
                    label="Status"
                    onChange={(event) => setStatus(event.target.value)}
                  >
                    <MenuItem value='ativo'>Ativo</MenuItem>
                    <MenuItem value='inativo'>Inativo</MenuItem>
                  </Select>
                </FormControl>
              </Stack>}
          </>
        </section>
        <footer className="modal-card-foot">
          <div className="buttons">
            <Button
              onClick={() => {
                selectedManage?.geral ? close() : !selectedManage?.id ? create('') : edit('');
              }}
              disabled={
                !name ||
                !manages ||
                !teams ||
                !serviceTypes ||
                (!selectedManage?.geral && serviceTypes?.some((ele) => !ele.conjuntosAssociados?.length)) ||
                isLoadingEdit ||
                isLoadingCreate
              }
              endIcon={selectedManage?.geral ? <IoCloseCircle/> : <SaveIcon />}
              className='button is-success'
              variant='contained'>
              {selectedManage?.geral ? 'Fechar' : 'Salvar'}
            </Button>
          </div>
        </footer>
      </div>
    </div>
  );
}
